import { render, staticRenderFns } from "./7_Email.vue?vue&type=template&id=18a3a4ca&scoped=true&"
import script from "./7_Email.vue?vue&type=script&lang=js&"
export * from "./7_Email.vue?vue&type=script&lang=js&"
import style0 from "./7_Email.vue?vue&type=style&index=0&id=18a3a4ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a3a4ca",
  null
  
)

export default component.exports